@value sidebar-width: 200px;
@value stack-spacing: 16px;

.sidebar-container {
    width: sidebar-width;
    flex-shrink: 0;
}

.table-wrapper {
    width: calc(100% - sidebar-width - stack-spacing);
}

.loading-container {
    height: 400px;
}
